import { Divider, Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { TJobRenderComponentProps } from '@/console/features/jobs/components/jobs-list/jobs-list-renderer.types';
import { useFeatureV2 } from '@/console/features/pipelines/hooks/use-feature/use-feature-v2';
import { TGetFeatureProps } from '@/console/features/pipelines/hooks/use-feature/use-feature.types';
import { FeatureOptionsTable } from '@/shared/components/ui/feature-options-table/feature-options-table';
import { useReadDevicesByIdsQuery } from '@/shared/redux/api/assets/devices/devices-api';
import { useReadProjectsByIdsQuery } from '@/shared/redux/api/assets/projects/projects-api';

export const FeatureOptionsRenderer: React.FC<TJobRenderComponentProps> = ({
  job,
}) => {
  const { t } = useTranslation();
  const { getFeature } = useFeatureV2();
  const { data: projectsData } = useReadProjectsByIdsQuery(
    { projectIds: job?.projectIds! },
    { skip: !job?.projectIds?.length },
  );
  const { data: devicesData } = useReadDevicesByIdsQuery(
    { deviceIds: job?.deviceIds! },
    { skip: !job?.deviceIds?.length },
  );

  const referenceDevice = devicesData?.readDevicesByIds?.items?.[0];
  const referenceProject = projectsData?.readProjectsByIds?.items?.[0];

  const feature = getFeature({
    feature: job?.jobType!,
    ...(referenceDevice || referenceProject),
  } as TGetFeatureProps);

  if (!feature?.options?.length) {
    return null;
  }

  return (
    <>
      <Divider />
      <Stack gap="1rem">
        <Typography variant="p6">{t('pipelines:options')}</Typography>
        <FeatureOptionsTable
          options={feature?.options}
          values={job?.featureOptions}
        />
      </Stack>
    </>
  );
};
